import { debounceTime, distinctUntilChanged, fromEvent } from 'rxjs';
const DEBOUNCE_TIME = 250;
export class ResizeService {
    resizeEvent$;
    watch() {
        if (!this.resizeEvent$) {
            this.resizeEvent$ = fromEvent(window, 'resize').pipe(debounceTime(DEBOUNCE_TIME), distinctUntilChanged());
        }
        return this.resizeEvent$;
    }
}
